export default {
  name: 'Name',
  durationInMins: 'Duration in minutes',
  createProduct: 'Create product'
}



// WEBPACK FOOTER //
// ./src/i18n/en/routes/product.js